import { z } from 'zod';
import { DefaultValues } from 'react-hook-form';
import { freeze } from '@reduxjs/toolkit';
import { measureFilterSchema, singleMeasureFilterSchema } from './validation';

type ISingleMeasureFilter = z.infer<typeof singleMeasureFilterSchema>;
export type IMeasureFilterState = z.infer<typeof measureFilterSchema>;

export const defaultSingleMeasureFilter: ISingleMeasureFilter = freeze(
  {
    measureKey: '',
    relOpKey: null,
    fromValue: null,
    toValue: null,
    value: null,
  },
  true,
);

export const defaultMeasureFilterState: DefaultValues<IMeasureFilterState> =
  freeze(
    {
      filters: [],
    },
    true,
  );
